import { Mail, Shield } from "lucide-react";
import { motion } from "framer-motion";
import React from "react";

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-background py-20 flex items-center">
      <div className="max-w-7xl mx-auto px-4 w-full grid md:grid-cols-2 gap-12">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <h1 className="text-4xl font-bold text-primary mb-6">Get in Touch</h1>
          <p className="text-gray-600 text-lg mb-8">
            For academic inquiries regarding the MALDROID thesis or
            collaboration opportunities, please reach out to the researchers or the Department of
            Computer Science.
          </p>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-3 rounded-lg text-secondary">
                <Shield className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900">
                  Department of Computer Science
                </h3>
                <p className="text-gray-600">College of Computing Studies</p>
                <p className="text-gray-600">
                  Western Mindanao State University{" "}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="bg-primary/10 p-3 rounded-lg text-primary">
                <Mail className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900">Location</h3>
                <p className="text-gray-600">Zamboanga City, Philippines </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100"
        >
          <h2 className="text-2xl font-bold text-gray-900 mb-6">
            Send a Message
          </h2>
          <form className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Full Name
              </label>
              <input
                type="text"
                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all"
                placeholder="John Doe"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all"
                placeholder="john@example.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Message
              </label>
              <textarea
                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all h-32"
                placeholder="I'm interested in the Random Forest results..."
              ></textarea>
            </div>
            <button className="w-full bg-primary text-white font-bold py-3 rounded-lg hover:bg-blue-800 transition-colors">
              Send Inquiry
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default ContactUs;
